import React from 'react';

export type LoadingButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  loadingLabel?: string;
  variant?: 'primary' | 'default' | 'ghost' | 'danger';
};

export default function LoadingButton({
  loading = false,
  loadingLabel,
  variant = 'default',
  disabled,
  children,
  className = '',
  type = 'button',
  ...rest
}: LoadingButtonProps) {
  const variantClass =
    variant === 'primary'
      ? 'btn-primary'
      : variant === 'ghost'
        ? 'btn-ghost'
        : variant === 'danger'
          ? 'btn-danger'
          : '';

  return (
    <button
      type={type}
      className={['btn', variantClass, loading ? 'btn--loading' : '', className].filter(Boolean).join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <>
          <span className="spinner spinner--inline" aria-hidden />
          {loadingLabel ?? children}
        </>
      ) : (
        children
      )}
    </button>
  );
}
